<!--
  @Description: 图片预览
  @Author: wang.y 
  @Date: 2023-12-26 
-->
<template>
  <div>
    <Modal class="preview-pic-modal" v-model="show" :footer-hide="true" :transfer="false" width="auto">
      <img :src="imgUrl | logo_show" v-if="imgType == 1" :style="'width: ' + imgWidth"/>
      <img :src="imgUrl" :style="'width: ' + imgWidth" v-else />
    </Modal>
  </div>
</template>
<script>
export default {
  components: {},
  created() {},
  mounted() {},
  data() {
    return {
      show: false,
      imgUrl: '',
      imgType: 1,
      imgWidth: 'auto'
    }
  },
  computed: {},
  methods: {},
}
</script>
<style lang='stylus' scoped>
.preview-pic-modal
  >>> .ivu-modal-wrap
    display flex
    align-items center
    justify-content center
  >>> .ivu-modal
    top auto
    width fit-content
    .ivu-modal-content
      border-radius 0
    .ivu-modal-close
      right 0
      top 0
    .ivu-modal-body
      font-size 0
      min-width 260px
      min-height 280px
      display flex
      align-items center
      justify-content center
      img
        max-height 500px
        max-width 1200px
</style>